module.exports = __webpack_public_path__ + "img/CO443726(3).4f72a413.png";